import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { restPasswordForUserInitiated } from '../../../store/user/user.actions'
import { Stack, Typography } from '@mui/material'
import TextFieldComponent from '@professocial/professocialFormComponents/FormComponents/TextFieldComponent'
import PreloaderButton from '@professocial/professocialFormComponents/FormComponents/PreloaderButton'
import DOMPurify from 'dompurify'
import { namedRequestData } from '../../../store/common/common.selectors'
import { LoginRootState } from '../../../store/loginRoot.reducer'
import { ActionCall } from '@professocial/professocialTypes'

interface Props {
  onClose: (e: boolean) => void
}

const ForgotPassword: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const dispatchForgotPassword = useCallback((username: string) => dispatch(restPasswordForUserInitiated({ username })), [dispatch])

  const [userLogin, setUserLogin] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [successSendResetMail, setSuccessSendResetMail] = useState<boolean>(false)

  const statusOnForgotPasswordRequest: ActionCall | undefined = useSelector((state: LoginRootState) => namedRequestData(state, restPasswordForUserInitiated.type))

  const onPasswordReset = () => {
    if (userLogin) {
      dispatchForgotPassword(userLogin)
      setLoading(true)
    }
  }

  useEffect(() => {
    setSuccessSendResetMail(false)
  }, [])


  useEffect(() => {
    if (statusOnForgotPasswordRequest?.status === 'success') {
      setLoading(false)
      setSuccessSendResetMail(true)
    }
  }, [statusOnForgotPasswordRequest])

  return (
    <Stack spacing={4}>
      {successSendResetMail ? (
        <Stack spacing={2} textAlign='center'>
          <Typography variant='h2'>{t('login:resetPasswordSuccessHeadline')}</Typography>
          <Typography dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(t('login:resetPasswordSuccessHeadText')) }}></Typography>
        </Stack>
      ) : (
        <TextFieldComponent
          label={t('login:username')}
          onChange={(event) => setUserLogin(event.currentTarget.value)}
          required
          fullWidth
        />
      )}
      <PreloaderButton
        onClick={successSendResetMail ? () => {
          props.onClose(false)
          setSuccessSendResetMail(false)
        } : onPasswordReset}
        color='primary'
        text={successSendResetMail ? t('login:resetPasswordClose') : t('login:passwordReset')}
        loading={loading}
        position='right'
        disableButton={!userLogin}
      />
    </Stack>
  )
}

export default ForgotPassword
